/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routerOptions from '@/router';
import snarkdown from 'snarkdown';
import App from './App.vue';
import getContent from './content';
import '@/assets/styles/index.css';
import '@/assets/styles/custom.css';
import PortalVue from 'portal-vue';
import './registerServiceWorker';
import VueMeta from 'vue-meta';
import '@/plugins/vee-validate';
import '@/plugins/axios';
import '@/plugins/v-calendar';
import '@/plugins/recaptcha';
import store from './store';
import VueGtag from "vue-gtag";
const router = new VueRouter(routerOptions);
Vue.use(VueRouter);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GA_ID },
    pageTrackerScreenviewEnabled: true,
    pageTrackerTemplate(to) {
        var _a, _b;
        return {
            page_title: (_b = (_a = to.meta) === null || _a === void 0 ? void 0 : _a.ga) === null || _b === void 0 ? void 0 : _b.page_title,
            page_path: to.path,
            page_location: window.location.href,
            page_referrer: document.referrer,
            campaign: '',
            medium: '',
            activity_type: 'page_view',
            session_start: '',
            first_visit: '',
            engagement_time_msec: ''
        };
    }
}, router);
Vue.prototype.$getContent = getContent;
Vue.prototype.$parseMarkdown = snarkdown;
new Vue({
    el: '#app',
    router,
    render: (h) => h(App),
    store,
    mounted() {
        // You'll need this for renderAfterDocumentEvent.
        this.$el['data-server-rendered'] = 'true';
        document.dispatchEvent(new Event('render-event'));
    },
});
